<template>
<div class="companyList companyListCom" >
        <div class="chainTitle">相关公司</div>
        <div class="box">
            <DataEmpty v-if="isEmpty"></DataEmpty>
            <ul v-else >
                <li v-if="tableData1.length>0">
                    <div class="top">同行公司</div>
                    <el-table :data="tableData1" border @cell-click="clickCompanyName">
                        <el-table-column prop="securityName"></el-table-column>
                    </el-table>
                </li>
                <li v-if="tableData2.length>0">
                     <div class="top">下游客户</div>
                    <el-table :data="tableData2" border @cell-click="clickCompanyName">
                        <el-table-column prop="securityName" ></el-table-column>
                    </el-table>
                </li>
                <li v-if="tableData3.length>0">
                     <div class="top">供应商</div>
                    <el-table :data="tableData3" border @cell-click="clickCompanyName">
                        <el-table-column prop="securityName" ></el-table-column>
                    </el-table>
                </li>
                <li v-if="tableData4.length>0">
                     <div class="top">核心子公司</div>
                    <el-table :data="tableData4" border @cell-click="clickCompanyName">
                        <el-table-column prop="securityName" ></el-table-column>
                    </el-table>
                </li>
            </ul>
        </div>
       
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import DataEmpty from '../../productInfoComponents/dataEmpty.vue'

  export default {
    name: 'companyList',
    data() {
        return {
            tableData1: [],     //同行公司
            tableData2: [],     //下游客户
            tableData3: [],     //供应商
            tableData4: [],     //核心子公司,
            isEmpty:false,
        }
    },
    components:{DataEmpty},
    computed:{...mapState(['indexSearchInfo','productRouterInfo'])},
    created(){
        this.getRelatedCompany(this.productRouterInfo);
    },
    methods: {
        //获取公司相关信息
        getRelatedCompany(params){
            this.isEmpty = false;
            this.$store.dispatch('getRelatedCompany',{coCode:params.coCode}).then( res => {
                if( res.data.retCode == '000'){
                    this.tableData1 = res.data.data.peerList
                    this.tableData2 = res.data.data.downList
                    this.tableData3 = res.data.data.supplierList
                    this.tableData4 = res.data.data.sonList
                    if(this.tableData1.length==0&&this.tableData2.length==0&&this.tableData3.length==0&&this.tableData4.length==0){
                        this.isEmpty = true;
                    }
                }
            })
        },
        //点击公司，跳转相应公司
        clickCompanyName(row, event, column){
            let params = {}
            params.name = row.securityName;
            params.code = row.securityCode;
            params.coCode = row.coCode
            params.type = 'company'
            this.$store.dispatch('productRouterInfo',params);
        }


    },
    mounted() {
      
    }
  }
</script>

<style lang="scss" src="../../../sass/productInfo/companyList.scss"></style>


// WEBPACK FOOTER //
// src/components/productInfoComponents/companyCom/companyList.vue